var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    [
      _c("b-col", { attrs: { cols: "12" } }, [
        _c(
          "div",
          { staticClass: "d-flex justify-content-end my-1" },
          [
            _vm.HasPermission(_vm.PermissionList.Sales_Create)
              ? _c(
                  "b-button",
                  {
                    attrs: { variant: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.sendQuote()
                      },
                    },
                  },
                  [
                    _c("span", { staticClass: "text-nowrap" }, [
                      _vm._v("Add Quotation"),
                    ]),
                  ]
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
      _c(
        "b-col",
        { staticClass: "my-1", attrs: { md: "2", sm: "4" } },
        [
          _c(
            "b-form-group",
            { staticClass: "mb-0" },
            [
              _c(
                "label",
                { staticClass: "d-inline-block text-sm-left mr-50" },
                [_vm._v("Per page")]
              ),
              _c("b-form-select", {
                staticClass: "w-50",
                attrs: {
                  id: "perPageSelect",
                  size: "sm",
                  options: _vm.pageOptions,
                },
                model: {
                  value: _vm.perPage,
                  callback: function ($$v) {
                    _vm.perPage = $$v
                  },
                  expression: "perPage",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-col",
        {
          staticClass: "d-flex justify-content-end mb-2",
          staticStyle: { position: "relative", "z-index": "1" },
          attrs: { cols: "12" },
        },
        [
          _c(
            "b-button",
            {
              attrs: { variant: "outline-danger", size: "sm" },
              on: { click: _vm.clearFilters },
            },
            [_vm._v(" Clear Filters ")]
          ),
        ],
        1
      ),
      _c(
        "b-col",
        { attrs: { cols: "12" } },
        [
          _c("b-table", {
            attrs: {
              striped: "",
              hover: "",
              responsive: "",
              "per-page": _vm.perPage,
              "current-page": _vm.currentPage,
              items: _vm.filteredQuotations,
              fields: _vm.fields,
              "sort-by": _vm.sortBy,
              "sort-desc": _vm.sortDesc,
              "sort-direction": _vm.sortDirection,
            },
            on: {
              "update:sortBy": function ($event) {
                _vm.sortBy = $event
              },
              "update:sort-by": function ($event) {
                _vm.sortBy = $event
              },
              "update:sortDesc": function ($event) {
                _vm.sortDesc = $event
              },
              "update:sort-desc": function ($event) {
                _vm.sortDesc = $event
              },
              filtered: _vm.onFiltered,
            },
            scopedSlots: _vm._u([
              {
                key: "head(quotationNo)",
                fn: function (scope) {
                  return [
                    _c(
                      "div",
                      { staticClass: "d-flex flex-column" },
                      [
                        _c("span", [_vm._v("Quotation No")]),
                        _c("b-form-input", {
                          attrs: {
                            placeholder: "Search Quotation No",
                            size: "sm",
                          },
                          on: { input: _vm.filterTable },
                          model: {
                            value: _vm.filters.quotationNo,
                            callback: function ($$v) {
                              _vm.$set(_vm.filters, "quotationNo", $$v)
                            },
                            expression: "filters.quotationNo",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                },
              },
              {
                key: "head(createdOn)",
                fn: function (scope) {
                  return [
                    _c(
                      "div",
                      { staticClass: "d-flex flex-column" },
                      [
                        _c(
                          "span",
                          {
                            staticStyle: { cursor: "pointer" },
                            on: {
                              click: function ($event) {
                                return _vm.toggleSort("createdOn")
                              },
                            },
                          },
                          [_vm._v("Created On")]
                        ),
                        _c("DatePicker", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            range: "",
                            format: "YYYY-MM-DD",
                            placeholder: "Select date range",
                          },
                          on: { change: _vm.applyDateFilters },
                          model: {
                            value: _vm.filters.createdOnRange,
                            callback: function ($$v) {
                              _vm.$set(_vm.filters, "createdOnRange", $$v)
                            },
                            expression: "filters.createdOnRange",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                },
              },
              {
                key: "head(dueDate)",
                fn: function (scope) {
                  return [
                    _c(
                      "div",
                      { staticClass: "d-flex flex-column" },
                      [
                        _c(
                          "span",
                          {
                            staticStyle: { cursor: "pointer" },
                            on: {
                              click: function ($event) {
                                return _vm.toggleSort("dueDate")
                              },
                            },
                          },
                          [_vm._v("Due Date")]
                        ),
                        _c("DatePicker", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            range: "",
                            format: "YYYY-MM-DD",
                            placeholder: "Select date range",
                          },
                          on: { change: _vm.applyDateFilters },
                          model: {
                            value: _vm.filters.dueDateRange,
                            callback: function ($$v) {
                              _vm.$set(_vm.filters, "dueDateRange", $$v)
                            },
                            expression: "filters.dueDateRange",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                },
              },
              {
                key: "head(status)",
                fn: function (scope) {
                  return [
                    _c(
                      "div",
                      { staticClass: "d-flex flex-column" },
                      [
                        _c("span", [_vm._v("STATUS")]),
                        _c(
                          "b-form-select",
                          {
                            attrs: { size: "sm" },
                            on: { input: _vm.filterTable },
                            model: {
                              value: _vm.filters.status,
                              callback: function ($$v) {
                                _vm.$set(_vm.filters, "status", $$v)
                              },
                              expression: "filters.status",
                            },
                          },
                          [
                            _c("option", { attrs: { value: "" } }, [
                              _vm._v("All"),
                            ]),
                            _c("option", { attrs: { value: "NEW" } }, [
                              _vm._v("NEW"),
                            ]),
                            _c("option", { attrs: { value: "PROFORMA" } }, [
                              _vm._v("PROFORMA"),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]
                },
              },
              {
                key: "cell(status)",
                fn: function (data) {
                  return [
                    data.item.status === 0
                      ? _c("b-badge", { attrs: { variant: "secondary" } }, [
                          _vm._v("New"),
                        ])
                      : data.item.status === 3
                      ? _c("b-badge", { attrs: { variant: "info" } }, [
                          _vm._v("Proforma"),
                        ])
                      : _vm._e(),
                  ]
                },
              },
              {
                key: "cell(createdOn)",
                fn: function (data) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.convertTimestampToDate(data.item.createdOn)
                        ) +
                        " "
                    ),
                  ]
                },
              },
              {
                key: "cell(dueDate)",
                fn: function (data) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(_vm.convertTimestampToDate(data.item.dueDate)) +
                        " "
                    ),
                  ]
                },
              },
              {
                key: "cell(total)",
                fn: function (data) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(
                          data.item.currency == null
                            ? "Rs"
                            : _vm.getCurrencySymbol(data.item.currency)
                        ) +
                        " " +
                        _vm._s(data.item.total.toFixed(2)) +
                        " "
                    ),
                  ]
                },
              },
              {
                key: "cell(actions)",
                fn: function (data) {
                  return [
                    _c(
                      "div",
                      { staticClass: "d-flex" },
                      [
                        _vm.HasPermission(_vm.PermissionList.Sales_View)
                          ? _c(
                              "b-button",
                              {
                                staticClass: "mr-2",
                                attrs: {
                                  to: _vm.getQuotationView(data.item.id),
                                  variant: "success",
                                },
                              },
                              [
                                _c("feather-icon", {
                                  staticClass: "text-body align-middle mr-1",
                                  attrs: { icon: "EyeIcon", size: "16" },
                                }),
                                _vm._v(" View "),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.HasPermission(_vm.PermissionList.Sales_Update) &&
                        data.item.status === 0
                          ? _c(
                              "b-button",
                              {
                                attrs: {
                                  to: _vm.getQuotationEdit(data.item.id),
                                  variant: "info",
                                },
                              },
                              [
                                _c("feather-icon", {
                                  staticClass: "text-body align-middle mr-1",
                                  attrs: { icon: "Edit2Icon", size: "16" },
                                }),
                                _vm._v(" Edit "),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
          _c(
            "div",
            { staticClass: "d-flex justify-content-center mb-1" },
            [
              _vm.quotation.length === 0
                ? _c(
                    "b-alert",
                    {
                      staticClass: "d-flex justify-content-center",
                      attrs: { variant: "warning", show: "" },
                    },
                    [
                      _c("h4", { staticClass: "alert-heading" }, [
                        _vm._v("No Quotations yet"),
                      ]),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-col",
        { attrs: { cols: "12" } },
        [
          _c("b-pagination", {
            staticClass: "my-0",
            attrs: {
              "total-rows": _vm.totalRows,
              "per-page": _vm.perPage,
              align: "center",
              size: "sm",
            },
            model: {
              value: _vm.currentPage,
              callback: function ($$v) {
                _vm.currentPage = $$v
              },
              expression: "currentPage",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }